/* MK facets v3 — delegated events + AJAX filtering (no full page reloads). */
(function () {
  var KEY = 'mkfState';
  function save(s){try{sessionStorage.setItem(KEY,JSON.stringify(s))}catch(e){}}
  function load(){try{return JSON.parse(sessionStorage.getItem(KEY)||'null')}catch(e){return null}}
  function drawer(){return document.querySelector('.mkf-drawer')}
  function catcher(){return document.querySelector('.mkf-catch')}
  function panelsShow(id){var d=drawer(); if(!d)return;
    [].forEach.call(d.querySelectorAll('.mkf-panel'),function(p){p.hidden=p.dataset.panel!==id});
    var st=load()||{}; st.panel=id; save(st)}
  function open(noAnim){var d=drawer(); if(!d)return;
    if(noAnim)d.classList.add('no-anim');
    d.classList.add('is-open');
    if(catcher())catcher().style.display='block';
    document.body.classList.add('mkf-lock');
    if(noAnim)requestAnimationFrame(function(){d.classList.remove('no-anim')});
    var st=load()||{}; st.open=true; st.panel=st.panel||'root'; save(st);
    panelsShow(st.panel)}
  function close(){var d=drawer(); if(!d)return;
    d.classList.remove('is-open');
    if(catcher())catcher().style.display='none';
    document.body.classList.remove('mkf-lock');
    save({open:false,panel:'root'})}

  var busy=false;
  function swapIds(doc){var seen={},ids=[];
    [document,doc].forEach(function(root){ if(!root)return;
      [].forEach.call(root.querySelectorAll('.shopify-section'),function(s){
        if(s.querySelector('.mkf-toolbar')||s.querySelector('[id^="mk-pills-"]')||s.querySelector('.mk-colhead')){
          if(!seen[s.id]){seen[s.id]=1;ids.push(s.id)}}})});
    return ids}
  function ajaxNav(url,push){
    if(busy)return; busy=true;
    var grid=document.querySelector('results-list');
    if(grid){grid.style.opacity='.45';grid.style.pointerEvents='none'}
    fetch(url,{headers:{'Accept':'text/html'}}).then(function(r){return r.text()}).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      swapIds(doc).forEach(function(id){
        var cur=document.getElementById(id), nw=doc.getElementById(id);
        if(cur&&nw) cur.replaceWith(nw)});
      if(push!==false) history.pushState({mkf:1},'',url);
      var t=doc.querySelector('title'); if(t)document.title=t.textContent;
      busy=false;
      var st=load(); if(st&&st.open) open(true);
    }).catch(function(){ busy=false; location.assign(url) });
  }
  window.addEventListener('popstate',function(){ajaxNav(location.href,false)});

  document.addEventListener('click',function(e){
    if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey) return;
    var t=e.target, el;
    if(el=t.closest('[data-mkf-open]')){open(false);return}
    if(el=t.closest('[data-mkf-close]')){close();return}
    if(t.closest('.mkf-catch')){close();return}
    if(el=t.closest('[data-mkf-goto]')){panelsShow(el.getAttribute('data-mkf-goto'));return}
    if(el=t.closest('[data-mkf-back]')){panelsShow('root');return}
    if(el=t.closest('[data-mkf-sortval]')){e.preventDefault();
      var u=new URL(location.href); u.searchParams.set('sort_by',el.getAttribute('data-mkf-sortval')); u.searchParams.delete('page');
      ajaxNav(u.toString()); return}
    if(el=t.closest('.mk-skip')){
      var cur=el.closest('.mk-stage'); var root=cur.parentElement;
      var stages=[].slice.call(root.querySelectorAll('.mk-stage'));
      var i=stages.indexOf(cur); cur.style.display='none';
      for(var j=i+1;j<stages.length;j++){ if(stages[j]){stages[j].style.display='flex';return} }
      var wrap=root.closest('[id^="mk-pills-"]'); if(wrap)wrap.style.display='none'; return}
    var a=t.closest('a.mkf-val, a.mkf-chip, a.mkf-clear, [id^="mk-pills-"] a');
    if(a){var h=a.getAttribute('href');
      if(h && h.charAt(0)==='/'){e.preventDefault(); ajaxNav(a.href); return}}
  });
  document.addEventListener('change',function(e){
    var s=e.target.closest('.mkf-sort'); if(!s)return;
    var u=new URL(location.href); u.searchParams.set('sort_by',s.value); u.searchParams.delete('page');
    ajaxNav(u.toString())});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close()});

  function priceBoxes(){return [].slice.call(document.querySelectorAll('.mkf-pricebox'))}
  function syncBox(box){
    var rs=box.querySelectorAll('.mkf-range'), ns=box.querySelectorAll('.mkf-price-num');
    var lo=+rs[0].value, hi=+rs[1].value;
    if(lo>hi){var tmp=lo;lo=hi;hi=tmp}
    var bmin=+box.dataset.boundMin, bmax=+box.dataset.boundMax, span=bmax-bmin||1;
    var fill=box.querySelector('.mkf-slider-fill');
    fill.style.left=((lo-bmin)/span*100)+'%';
    fill.style.right=(100-(hi-bmin)/span*100)+'%';
    ns[0].value=lo; ns[1].value=hi;
  }
  function initPrice(){priceBoxes().forEach(syncBox)}
  document.addEventListener('input',function(e){
    var r=e.target.closest('.mkf-range'); if(!r)return;
    syncBox(r.closest('.mkf-pricebox'));
  });
  document.addEventListener('change',function(e){
    var box=e.target.closest('.mkf-pricebox'); if(!box)return;
    if(e.target.classList.contains('mkf-price-num')){
      var rs=box.querySelectorAll('.mkf-range'), ns=box.querySelectorAll('.mkf-price-num');
      rs[0].value=ns[0].value||box.dataset.boundMin; rs[1].value=ns[1].value||box.dataset.boundMax;
      syncBox(box);
    }
    var ns2=box.querySelectorAll('.mkf-price-num');
    var lo=+ns2[0].value, hi=+ns2[1].value;
    var u=new URL(location.href);
    if(lo> +box.dataset.boundMin) u.searchParams.set('filter.v.price.gte',lo); else u.searchParams.delete('filter.v.price.gte');
    if(hi< +box.dataset.boundMax) u.searchParams.set('filter.v.price.lte',hi); else u.searchParams.delete('filter.v.price.lte');
    u.searchParams.delete('page');
    ajaxNav(u.toString());
  });
  var _origAjax=ajaxNav;
  // re-sync sliders after swaps
  var mo=new MutationObserver(function(){initPrice()});
  mo.observe(document.body,{childList:true,subtree:true});
  initPrice();

  var st=load(); if(st&&st.open) open(true);
})();
